import {EventBus} from "OK/EventBus";

const TOOLBAR_MANAGER_EVENT_BUSES_PREFIX = 'toolbarManager';

export interface IToolbarManagerVisibilityParams {
    hide: boolean;
}

export interface IToolbarManagerLoadingParams {
    loading: boolean;
}

const create = EventBus.factory(TOOLBAR_MANAGER_EVENT_BUSES_PREFIX);

export const VISIBILITY_TOOLBAR_NAV = create<IToolbarManagerVisibilityParams>("visibilityToolbarNavigation");

export const INDICATE_LOADING_REACT_TOOLBAR_SEARCH = create<IToolbarManagerLoadingParams>("indicateLoadingReactToolbarSearch");
